<script>
  import {omitBy,isEqual} from 'lodash'
    export default {
      name: "control-table-view",
      props:{
        schemaUrl:{
          type:String,
          required:true
        },
        createEntityDialogOptions:{
          type:Object,
          default: ()=>{
            return {
              "header": "Создание",
              "applyBtnName": "Применить",
              "cancelBtnName": "Отменить"
            }
          }
        },
        editEntityDialogOptions:{
          type:Object,
          default: ()=>{
            return {
              "header": "Редактирование",
              "applyBtnName": "Применить",
              "cancelBtnName": "Отменить"
            }
          }
        },
        rowStyle:{
          type:Function,
        },
        colStyle:{
          type:Function,
        },
        editableColumn:{
          type:Boolean,
          default:true,
        },
        stepsOfSizeRows:{
          type:Array,
          default:()=>[10,20,50,100]
        },
        withDetailRow:{
          type:Boolean,
          default:true
        },
        withCheckboxes:{
          type:Boolean,
          default:true
        },
      },
      data(){
         return {
           rowsFetchParams:{
             url:null,//копируется из схемы
             params:{
               page:0,
               size:10,
               search:null,//формируется из filters
             }
           },
           selectedRows:[],
           expandedRow:null,
           sortAscending:{},
           filters:[],
           showCreateEntityDialog:false,
           cacheModelForCreateEntityDialog:null,
           showSchemaFilterDialog:false,
           columnsByProperties:[]
         }
      },
      computed:{
        columns(){
          let columns=[]

          if (this.editableColumn&&this.schema){
            const editableColumn = {
              title:'',
              layout2:this.$compLayouts.editEntityBySchemaButton("externalData.rowData",this.schema,this.editEntityDialogOptions)
            }
            columns = [editableColumn]
          }

          return columns.concat(this.columnsByProperties);
        }
      },
      asyncComputed: {
        schema:{
          get(){return this.$jsonSchemeUtils.checkOnLoadHyperSchema(this.schemaUrl)},
          eager: true,
          watch:'schemaUrl',
          transform(result) { return result },
        },
        rows:{
          get(){if(this.rowsFetchParams.url) return  Vue.axios(this.rowsFetchParams).then(responce=>responce.data).then(data=>data.content||data)},
          watch() {this.rowsFetchParams.url;this.rowsFetchParams.params.page;this.rowsFetchParams.params.size;this.rowsFetchParams.params.search;},
          //eager: true,
          default:[],
          transform(result) { return result },

        }
      },
      watch:{
        schema(newSchema){
          this.rowsFetchParams.url=(newSchema||{}).base

          this.columnsByProperties = newSchema?this.$tableLayout.columnsByProperties(
            omitBy(newSchema.properties,prop=>prop.format=="special"),
            {
              axiosParams:{
                "url":newSchema.base,
                "method":"PATCH",
              }
            }):[]


        }
      },
      methods:{
        rowClickedHandler(row){
          // const index = this.selectedRows.findIndex(selectedRow=>isEqual(selectedRow,row))
          // index>-1?this.selectedRows.splice(index, 1):this.selectedRows.push(row);
        },
        expandedRowHandler(row){
          isEqual(this.expandedRow,row)?this.expandedRow=null:this.expandedRow=row;
        },
        checkColumnClickedHandler(row,checked){
          const index = this.selectedRows.findIndex(selectedRow=>isEqual(selectedRow,row))
          checked?index==-1?this.selectedRows.push(row):"":this.selectedRows.splice(index, 1)
        },
        headerClickedHandler(col){
          if(col.sortable){
            //true->false->undefined->true
            Vue.set(this.sortAscending,col.path,
              this.sortAscending[col.path]
                ?false
                :this.sortAscending[col.path]==false
                  ?undefined
                  :true
            );
          }
        },

      },
      render(createElement) {
        const params = {
          "props":{
            "rows":this.rows,
            "columns":this.columns,
            "selectedRows":this.selectedRows,
            "expandedRow":this.expandedRow,
            "withDetailRow":this.withDetailRow,
            "withCheckboxes":this.withCheckboxes,
            "sortAscending":this.sortAscending,
            "rowStyle":this.rowStyle,//(row,rowIndex)=>rowIndex==0?'background-color:red':'',
            "colStyle":this.colStyle//(col,colIndex,row,rowIndex)=>rowIndex==1&&colIndex==4?'background-color:green':''
          },
          "on":{
            "rowClicked":this.rowClickedHandler,
            "checkColumnClicked":this.checkColumnClickedHandler,
            "expandRow":this.expandedRowHandler,
            "headerClicked":this.headerClickedHandler
          }
        }
        return createElement('div',{"style":{"padding":"15px"}},[
          createElement('div',{"style":{"display":"flex"}},[
            createElement('button',{
              "class":"ui primary button",
              "on":{
                "click":(e)=>this.showCreateEntityDialog=true
              }
            },['Добавить']),
            this.showCreateEntityDialog?createElement('schema-dialog',{
              "props": {
                "initModel":this.cacheModelForCreateEntityDialog,
                "hyperSchema":this.schema,
                "dialogOption":this.createEntityDialogOptions,
                "actionLink":"create"
              },
              "on": {
                "apply": (e)=>{this.showCreateEntityDialog=false;this.cacheModelForCreateEntityDialog=e},
                "cancel": (e)=>{this.showCreateEntityDialog=false;this.cacheModelForCreateEntityDialog=e},
              }
            }):null,
            createElement('div',{
              "class":"ui basic icon button",
              "style":"position:relative",
              "on":{
                "click":(e)=>this.showSchemaFilterDialog=true
              }
            },[
              this.filters.length>0?createElement('div',{"class":"floating ui mini violet label"},[this.filters.length]):null,
              createElement('i',{"class":"icon filter"})
            ]),
            this.showSchemaFilterDialog?createElement('filter-dialog',{
              "props": {
                "initFilters":this.filters,
                "filterProperties":this.schema.properties
              },
              "on": {
                "apply": (e)=>{this.filters=e; this.showSchemaFilterDialog=false},
                "cancel": (e)=>{this.showSchemaFilterDialog=false},
                "searchStr": (e)=>{this.rowsFetchParams.params.search=e},
              }
            }):null,
            createElement('dropdown-element',{
              "class":"ui basic icon top left pointing dropdown button",
              "props":{"inputIconClass":"wrench icon"}
            },[
              createElement('list-element',{
                "props":{
                  "items":this.columnsByProperties
                },
                "on":{
                  "input":(e)=>this.columnsByProperties=e
                },
                "scopedSlots":{
                  "default":props=>createElement('column-param-item',{
                    "props":{"column":props.item},
                    "key":props.item.path
                  })
                }
              })
            ]),
            this.selectedRows.length>0?createElement('dropdown-element',{
              "class":"ui dropdown button",
              "props":{
                "value":"Действия",
                "inputIconClass":"dropdown icon"
              }
            },[
              createElement('menu-item',{
                "props":{
                  "stopPropagation":false,
                  "items":[
                    {
                      "icon":"gamepad icon",
                      "title":"Удалить выбранные",
                      "action":(item,index)=>{this.$jsonSchemeUtils.removeEntities(this.schema,this.selectedRows.map(row=>row.id));this.selectedRows=[]}

                    }
                  ]
                }
              })
            ]):null,
            createElement('dropdown-element',{
              "class":"ui dropdown",
              "style":{
                "margin-left":"auto",
                "padding": "0.78571429em 0.78571429em 0.78571429em",
                "color":"grey"
              },
              "props":{
                "inputIconClass":"dropdown icon",
                "options":this.stepsOfSizeRows,
                "value":this.rowsFetchParams.params.size
              },
              "on":{
                "input":(e)=>this.rowsFetchParams.params.size=e
              }
            },[]),
            createElement('div',{"class":"ui input"},[
              createElement('input',{
                "style":{
                  "border":"none",
                  "width":"70px",
                  "padding-left":"0px",
                  "text-align":"center",
                  "color":"grey"
                },
                "attrs": {
                  "value":this.rowsFetchParams.params.page+1,
                  "type":"number",
                  "min":1
                },
                "on":{
                  "input":(e)=>this.rowsFetchParams.params.page=e.target.value-1
                }
              },[])
            ]),

          ]),
          createElement('control-table',params)
        ])

      }
    }
</script>

<style scoped>

</style>
